import * as Yup from 'yup';

let validationSchema = Yup.object({
  option_name: Yup.string(
    ('page.add_option_name_required')
  )
    .trim()
    .max(100, ('page.add_option_name_validation_max'))
    .required(('page.add_option_name_required')),

  option_note: Yup.string(
    ('page.add_option_note_required')
  )
    .trim()
    .required(('page.add_option_note_required')),

  option_status: Yup.string(
    ('page.add_option_status_required')
  )
    .required(('page.add_option_status_required')),

  option_color: Yup.string(
    ('page.add_option_color_required')
  )
    .required(('page.add_option_color_required'))
});

export default validationSchema;